import { gsap } from 'gsap';
export default function initHeroBanner(): void {
    const $heroBannerContainer = document.querySelectorAll<HTMLElement>('.hero-banner');

    $heroBannerContainer.forEach($container => {
        new HeroBanner($container);
    });
}

class HeroBanner {
    $el: HTMLElement | Element;
    $wrapperAnimation: HTMLElement | Element | null;
    observer : IntersectionObserver;

    constructor($el: HTMLElement | Element) {
        this.$el = $el;
        this.$wrapperAnimation = this.$el.querySelector('.wrapper-animation-bulle');
        this.onIntersection = this.onIntersection.bind(this);
        this.observer = new IntersectionObserver(this.onIntersection);

        if (this.$wrapperAnimation) {
            this.observer.observe(this.$el);
        }
    }

    /**
     * @param {IntersectionObserverEntry[]} entries
     */
    onIntersection(entries: IntersectionObserverEntry[]) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                this.initAnim();
                this.observer.unobserve(this.$el);
            }
        });
    }
    
    initAnim() {
        gsap.to(".bulle", {
            duration: 0.8,
            scale: 1,
            ease: "power1.inOut",
            stagger: {
                grid: [7,15],
                from: "center",
                amount: 1.5
            }
        });
    }
}
